import React from 'react';
import './Auth.css';

function AuthLayout({ children, title, subtitle, illustration }) {
  return (
    <div className="auth-container">
      {/* Left Side - Branding/Illustration */}
      <div className="auth-left">
        <div className="auth-brand">
          <h1>Pi<span>vot</span></h1>
          <p className="auth-tagline">IQ Workspace</p>
        </div>
        <div className="auth-illustration">
          <div className="auth-illustration-content">
            <i className="ti ti-health" style={{ fontSize: 64, color: 'var(--blue)' }} />
            <h2>Streamline Your Clinical Trials</h2>
            <p>Manage studies, documents, feasibility assessments, risks, and knowledge all in one place.</p>
            <div className="auth-features">
              <div className="auth-feature">
                <i className="ti ti-folder" />
                <span>Study Management</span>
              </div>
              <div className="auth-feature">
                <i className="ti ti-checklist" />
                <span>CRO Evaluation</span>
              </div>
              <div className="auth-feature">
                <i className="ti ti-shield" />
                <span>Risk Analytics</span>
              </div>
              <div className="auth-feature">
                <i className="ti ti-books" />
                <span>Knowledge Engine</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="auth-right">
        <div className="auth-form-container">
          <div className="auth-form-header">
            <h2>{title}</h2>
            <p className="auth-subtitle">{subtitle}</p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;